<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="glass-card mb-4" elevation="0">
          <v-card-title class="d-flex align-center pb-2 pt-4 px-6">
            <h2 class="text-h5 font-weight-bold primary--text mb-0">
              Validación de Videos
            </h2>
            <v-chip color="primary" dark small class="ml-3 font-weight-bold elevation-1">
              Mercadotecnia
            </v-chip>
            <v-spacer></v-spacer>

            <!-- Filtro de escuela (Oculto si se envía vía prop) -->
            <v-autocomplete
              v-if="!escuelaProp"
              v-model="escuelaSel"
              :items="escuelas"
              item-text="nombre"
              item-value="id"
              label="Escuela"
              outlined
              dense
              hide-details
              class="mr-4"
              style="max-width: 150px"
              @change="initialize()"
            ></v-autocomplete>

            <v-btn class="premium-btn text-capitalize font-weight-bold" color="primary" dark rounded @click="initialize()">
              <v-icon left>mdi-refresh</v-icon> Actualizar
            </v-btn>
          </v-card-title>
          
          <v-card-text class="px-6 pb-6 pt-0">
            <v-row justify="end" class="mb-4 mt-1">
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  label="Buscar videos..."
                  dense
                  outlined
                  rounded
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  v-model="search"
                  class="search-input"
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Loading State -->
            <v-row v-if="cargar" justify="center" class="py-12">
              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            </v-row>

            <!-- Empty State -->
            <v-row v-else-if="videosFiltrados.length === 0" justify="center" class="py-12 text-center">
              <v-col cols="12" md="6">
                <v-icon size="80" color="success lighten-2" class="mb-4">mdi-check-all</v-icon>
                <h3 class="text-h6 grey--text font-weight-medium text--darken-2">No hay videos pendientes</h3>
                <p class="grey--text">Todo está al día. ¡Buen trabajo!</p>
              </v-col>
            </v-row>

            <!-- Cards Grid -->
            <v-row v-else>
              <v-col
                v-for="item in videosFiltrados"
                :key="item.id_video_merca"
                cols="12"
                sm="6"
                md="4"
                lg="4"
                xl="3"
              >
                <v-card class="video-card rounded-lg transition-swing d-flex flex-column" hover elevation="3">
                  <!-- Thumbnail Placeholder -->
                  <div class="thumbnail-wrapper d-flex align-center justify-center bg-grey-lighten-4 pointer" @click="abrirVideo(item)">
                    <div class="play-overlay d-flex flex-column align-center justify-center">
                      <v-icon size="56" color="white" class="play-icon">mdi-play-circle</v-icon>
                      <span class="white--text font-weight-bold mt-1 text-shadow">Ver Video</span>
                    </div>
                  </div>

                  <v-card-text class="pa-4 flex-grow-1">
                    <div class="d-flex align-start mb-2">
                      <v-avatar size="36" color="info lighten-4" class="mr-3 mt-1 shadow-sm">
                        <span class="info--text font-weight-bold text-caption">{{ item.nombre ? item.nombre.charAt(0).toUpperCase() : 'U' }}</span>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-2 font-weight-bold text-truncate" style="max-width: 170px;" :title="item.nombre">
                          {{ item.nombre || 'Usuario Desconocido' }}
                        </div>
                        <div class="text-caption grey--text d-flex align-center">
                          <v-icon x-small class="mr-1 grey--text">mdi-video</v-icon>
                          {{ item.nombre_video || 'Video sin nombre' }}
                        </div>
                        <div class="text-caption grey--text d-flex align-center">
                          <v-icon x-small class="mr-1 grey--text">mdi-clock-outline</v-icon>
                          {{ item.fecha_subida }}
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4 bg-grey-lighten-5 justify-space-between border-top">
                    <v-btn
                      color="error"
                      text
                      class="px-2 font-weight-bold text-caption"
                      @click="rechazarVideoPrompt(item)"
                    >
                      <v-icon left small>mdi-close</v-icon> RECHAZAR
                    </v-btn>
                    
                    <v-btn
                      color="success"
                      dark
                      rounded
                      class="px-5 font-weight-bold text-caption"
                      @click="preguntarTransferencia(item)"
                      elevation="1"
                    >
                      <v-icon left small>mdi-check</v-icon> ACEPTAR
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- Dialog para confirmar transferencia -->
    <v-dialog v-model="dialogConfirmarTransferencia" max-width="450px" persistent>
      <v-card class="rounded-lg glass-dialog">
        <v-card-title class="py-3 px-5 d-flex align-center">
          <v-icon class="mr-2" color="primary">mdi-help-circle</v-icon>
          <span class="text-subtitle-1 font-weight-bold">Opciones de Aceptación</span>
        </v-card-title>
        <v-card-text class="pt-6 px-5 pb-2 text-body-2 mb-4 grey--text text--darken-2">
          ¿Deseas transferir este video al panel de <b>Gestión de Recursos (Multimedia)</b> o mandarlo directamente?
        </v-card-text>
        <v-card-actions class="px-5 pb-5 pt-2 d-flex flex-column">
          <v-btn color="primary" dark rounded block class="font-weight-bold mb-3" elevation="2" :loading="loadingTransferencia" @click="procederATransferir()">Transferir a Recursos</v-btn>
          <v-btn color="success" outlined rounded block class="font-weight-bold mb-3" @click="aceptarDirectamente()">Mandar Directamente</v-btn>
          <v-btn color="grey darken-1" text rounded block class="font-weight-bold" @click="dialogConfirmarTransferencia = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgSubida" max-width="560" persistent>
      <v-card>
        <v-card-title>Transferir Video</v-card-title>
        <v-card-text>
          <v-form ref="formSubida">
            <v-text-field v-model="formTransferir.nombre" label="Nombre *" outlined dense
              :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-autocomplete v-model="formTransferir.id_ciclo" :items="ciclosVisibles" item-text="ciclo" item-value="id"
              label="Ciclo *" outlined dense :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-autocomplete v-model="formTransferir.id_sucursal" :items="sucursalesList" item-text="nombre" item-value="id"
              label="Sucursal (Opcional - Aplica a todas)" outlined dense clearable />
            <v-autocomplete v-model="formTransferir.id_tipo" :items="tipos" item-text="nombre" item-value="id" label="Tipo *" outlined
              dense :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-autocomplete v-model="formTransferir.id_uso" :items="usos" item-text="nombre" item-value="id" label="Uso *" outlined
              dense :rules="[function (v) { return !!v || 'Requerido' }]" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgSubida = false">Cancelar</v-btn>
          <v-btn color="primary" class="white--text" :loading="guardando" @click="aceptarVideo()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    


    <!-- Dialog para visualizar el video -->
    <v-dialog v-model="dialogVideo" max-width="800px" overlay-color="#000" overlay-opacity="0.8">
      <v-card class="rounded-lg overflow-hidden" style="background-color: #0F0F0F !important; border: 1px solid #333 !important;">
        <v-card-title class="d-flex align-center py-3 px-4" style="background: #ffffff; border-bottom: 1px solid #222;">
          <v-avatar size="32" color="primary" class="mr-3">
            <span class="white--text text-caption font-weight-bold">{{ videoSelect ? (videoSelect.nombre ? videoSelect.nombre.charAt(0).toUpperCase() : 'U') : '' }}</span>
          </v-avatar>
          <span class="text-subtitle-1 font-weight-bold">{{ videoSelect ? videoSelect.nombre : '' }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" class="mr-2" @click="descargarVideo()">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon dark @click="dialogVideo = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <div style="background-color: #0F0F0F; display: flex; justify-content: center; align-items: center; min-height: 300px;">
          <video id="video-merca" :src="urlVideoActual" frameborder="0" controls controlsList="nodownload"
                 allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                 style="width: 100%; max-height: 80vh; outline: none; box-shadow: 0 4px 30px rgba(0,0,0,0.5);">
          </video>
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog para motivo de rechazo -->
    <v-dialog v-model="dialogRechazar" max-width="450px" persistent>
      <v-card class="rounded-lg glass-dialog">
        <v-card-title class="py-3 px-5 d-flex align-center">
          <v-icon class="mr-2 ">mdi-alert-octagon</v-icon>
          <span class="text-subtitle-1 font-weight-bold">Rechazar Video</span>
        </v-card-title>
        <v-card-text class="pt-6 px-5 pb-2">
          <p class="text-body-2 mb-4 grey--text text--darken-2">
            Por favor, indica un motivo de rechazo. Esto ayudará al equipo de recepción a corregir el error.
          </p>
          <v-textarea 
            v-model="motivo_rechazo" 
            label="Detalla el motivo" 
            rows="3" 
            outlined
            color="error"
            required
            hide-details
            class="rounded-lg custom-textarea"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="px-5 pb-5 pt-2">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text rounded class="font-weight-bold px-4" @click="dialogRechazar = false">Cancelar</v-btn>
          <v-btn color="error" dark rounded class="font-weight-bold px-6" @click="confirmarRechazo()" :loading="loadingAction">Rechazar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar && !dialogVideo && !dialogRechazar" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';
import { mapGetters } from 'vuex';
import moment from "moment";
moment.locale('es');

export default {
  mixins: [validarErrores],
  components: {
    Alerta,
    carga
  },
  props: {
    escuelaProp: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    formTransferir: {
      id_recurso: null,
      nombre: null,
      id_ciclo: null,
      id_sucursal: null,
      id_tipo: null,
      id_uso: null,
    },
    ciclosList: [],
    sucursalesList: [],
    tipos: [],
    usos: [],
    dlgSubida: false,
    guardando: false,
    colorTema: "#0047AB",
    respuestaAlerta: false,
    cargar: false,
    loadingAction: false,
    search: '',
    dialogConfirmarTransferencia: false,
    loadingTransferencia: false,
    dialogVideo: false,
    dialogRechazar: false,
    videoSelect: null,
    motivo_rechazo: '',
    urlVideoActual: '',
    videosPendientes: [],
    escuelaSel: 1,
    escuelas: [
      { id: 1, nombre: 'INBI' },
      { id: 2, nombre: 'FAST' }
    ]
  }),
  computed: {
    ...mapGetters("login", ["getdatosUsuarioERPERP"]),
    videosFiltrados() {
      if (!this.search) return this.videosPendientes;
      const term = this.search.toLowerCase();
      return this.videosPendientes.filter(v => {
        return (
          (v.nombre && v.nombre.toLowerCase().includes(term)) ||
          (v.id_video_merca && v.id_video_merca.toString().includes(term))
        );
      });
    },
    inst() { 
      return Number(this.escuelaProp) === 1 ? 'inbi' : 'fast'; 
    },
    ciclosVisibles() { return this.ciclosList.filter(function (c) { return c.visible; }); },
  },
  created() {
    if (this.escuelaProp) {
      this.escuelaSel = this.escuelaProp;
    }
    this.initialize();
  },
  watch: {
    dialogVideo(val) {
        if (!val) {
            const videoElement = document.getElementById('video-merca');
            if (videoElement) {
                videoElement.pause();
                videoElement.currentTime = 0;
            }
        }
    },
    escuelaProp(newVal) {
      if (newVal) {
        this.escuelaSel = newVal;
        this.initialize();
      }
    }
  },
  methods: {
    initialize() {
      this.cargar = true;
      this.videosPendientes = [];
      const payload = { escuela: this.escuelaSel };
      
      this.$http.post(`videos.merca.pendientes`, payload)
        .then(response => {
           this.videosPendientes = response.data.map(v => {
               v.fecha_subida = moment(v.fecha_subida).format("DD MMM YYYY, HH:mm");
               return v;
           });
        })
        .catch(error => {
           const msg = (error.response && error.response.data) ? error.response.data.message : 'Error al obtener videos pendientes';
          this.validarError(msg);
        })
        .finally(() => { this.cargar = false; });
    },
    async cargarBase() {
      var rC = await this.$http.get('multimedia.ciclos.list?inst=' + this.inst);
      var rS = await this.$http.get('multimedia.sucursales.list?inst=' + this.inst);
      var rT = await this.$http.get('multimedia.tipos.list?inst=' + this.inst);
      var rU = await this.$http.get('multimedia.usos.list?inst=' + this.inst);
      this.ciclosList = rC.data.map(function (c) { 
        return Object.assign({}, c, { 
          visible: Number(c.visible) 
        }); 
      });
      this.sucursalesList = rS.data;
      this.tipos = rT.data;
      this.usos = rU.data;
    },
    preguntarTransferencia(item) {
      this.videoSelect = item;
      this.dialogConfirmarTransferencia = true;
    },
    aceptarDirectamente() {
      this.dialogConfirmarTransferencia = false;
      let itemDirecto = Object.assign({}, this.videoSelect);
      itemDirecto.transferir = false;
      this.ejecutarValidacionVideo(itemDirecto, 'ACEPTADO', null);
    },
    async procederATransferir() {
      if (this.ciclosList.length === 0) {
        this.loadingTransferencia = true;
        try {
          await this.cargarBase();
        } catch (error) {
          console.error("Error al cargar listados", error);
        } finally {
          this.loadingTransferencia = false;
        }
      }
      this.dialogConfirmarTransferencia = false;
      this.abrirModalSubir(this.videoSelect);
    },
    abrirModalSubir(item) {
      this.formTransferir = Object.assign({}, item);
      this.dlgSubida = true;
    },
    abrirVideo(item) {
       this.videoSelect = item;
       const baseUrl = this.$http.defaults.baseURL || '';
       const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
       this.urlVideoActual = base + item.ruta_video;
       this.dialogVideo = true;
    },
    async descargarVideo() {
        if (!this.urlVideoActual) return;
        try {
            const response = await fetch(this.urlVideoActual);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `Video_${this.videoSelect.id_video_merca}.mp4`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            window.open(this.urlVideoActual, '_blank');
        }
    },
    aceptarVideo(item) {
      let itemAceptar = item;
      if (this.formTransferir) {
        itemAceptar = this.formTransferir;
        itemAceptar.transferir = true;
      }
      this.dlgSubida = false;
      this.ejecutarValidacionVideo(itemAceptar, 'ACEPTADO', null);
    },
    rechazarVideoPrompt(item) {
        this.videoSelect = item;
        this.motivo_rechazo = '';
        this.dialogRechazar = true;
    },
    confirmarRechazo() {
        if (!this.motivo_rechazo || this.motivo_rechazo.trim() === '') {
            this.validarError("Debes especificar un motivo");
            return;
        }
        this.loadingAction = true;
        this.ejecutarValidacionVideo(this.videoSelect, 'RECHAZADO', this.motivo_rechazo)
            .finally(() => { 
                 this.loadingAction = false; 
                 this.dialogRechazar = false; 
            });
    },
    ejecutarValidacionVideo(item, estatus, motivo) {
        if (!this.getdatosUsuarioERPERP || !this.getdatosUsuarioERPERP.iderp) return Promise.reject();

        this.cargar = true;
        const payload = {
            id_video_merca: item.id_video_merca,
            estatus: estatus,
            motivo_rechazo: motivo,
            id_usuario_mercadotecnia: this.getdatosUsuarioERPERP.iderp,
            escuela: this.escuelaSel,
            ruta_video: item.ruta_video,
            id_usuario_recepcion: item.id_usuario_recepcion,
            transferir: item.transferir || false,
            id_ciclo: item.id_ciclo || null,
            id_sucursal: item.id_sucursal || null,
            id_tipo: item.id_tipo || null,
            id_uso: item.id_uso || null,
            nombre_recurso: item.nombre || item.nombre_video || null
        };

        return this.$http.put('videos.merca.verificar', payload)
            .then(response => {
                this.validarSuccess(response.data.message);
                this.initialize();
            })
            .catch(error => {
                const msg = (error.response && error.response.data) ? error.response.data.message : 'Ocurrió un error en la verificación';
                this.validarError(msg);
            })
            .finally(() => {
                this.cargar = false;
            });
    }
  }
};
</script>

<style scoped>
/* Glassmorphism & Cards */
.glass-card {
  background: white !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04) !important;
  border-radius: 16px !important;
}

.glass-dialog {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 16px 40px 0 rgba(0, 0, 0, 0.15) !important;
}

/* Video Cards */
.video-card {
  border: 1px solid rgba(0,0,0,0.05) !important;
  background: white !important;
}

.video-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 24px -4px rgba(0,0,0,0.12) !important;
  border-color: rgba(0,0,0,0.1) !important;
}

.thumbnail-wrapper {
  height: 180px;
  position: relative;
  background: linear-gradient(135deg, #1c3d5a 0%, #2980b9 100%);
  border-bottom: 1px solid rgba(0,0,0,0.05);
  overflow: hidden;
}

.play-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  opacity: 0.8;
  transition: all 0.3s ease;
}

.thumbnail-wrapper:hover .play-overlay {
  background: rgba(0,0,0,0.5);
  opacity: 1;
}

.play-icon {
  transition: transform 0.3s ease;
}

.thumbnail-wrapper:hover .play-icon {
  transform: scale(1.15);
}

.bg-grey-lighten-5 {
  background-color: #fafafa !important;
}

.pointer {
  cursor: pointer;
}

.border-top {
  border-top: 1px solid rgba(0,0,0,0.06);
}

/* Interactivity */
.hover-lift {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hover-lift:hover {
  transform: translateY(-2px);
}

/* Inputs */
.search-input .v-input__control > .v-input__slot {
  background: white !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04) !important;
}

.custom-textarea .v-input__control > .v-input__slot {
  border-radius: 12px !important;
  background: #fafafa;
}
</style>
